export const buildDetailsMapping = {
  FEBuildNumber: 'FE Build Number',
  FEBuildDate: 'FE Build Time',
  FEBuildFeatures: 'FE Build Features',
  BEBuildNumber: 'BE Build Number',
  BEBuildDate: 'BE Build Time',
};

export const abc = 'abc';

export const optionsMapping = {
  feFeatureSwitch: {
    hideRCSFiltersExcludeButton: {
      type: 'checkbox',
      label: 'RCS Filters - Hide Exclude button',
    },
    hideRCSStructureFilter: {
      type: 'checkbox',
      label: 'RCS Filters - Hide Structure filter',
    },
    hideRCSSDSFilter: {
      type: 'checkbox',
      label: 'RCS Filters - Hide SDS filter',
    },
    disablePatentSightUIChanges: {
      type: 'checkbox',
      label: 'Disable Reaxys PatentSight UI changes',
    },
    disableRccContentFrom: {
      type: 'checkbox',
      label: 'Disable RCC "Manually processed content only filter" on Documents',
    },
    enableRccDocumentProcessedTypeLabel: {
      type: 'checkbox',
      label: 'Enable RCC "manual/automation processed label" on Documents',
    },
    image_generation_requests_limit: {
      type: 'number',
      label: 'Image Generation Requests Limit',
    },
    disableCasNumberCta: {
      type: 'checkbox',
      label: 'Disable CAS API CTA',
    },
    enableProductSelection: {
      type: 'checkbox',
      label: 'Enable Product Selection',
    },
    enableInHouseForEditableRetrosynthesisPlans: {
      type: 'checkbox',
      label: 'Enable In-House For Editable Retrosynthesis Plans',
    },
    enableDisplaySupplierNumber: {
      type: 'checkbox',
      label: 'Enable Display Supplier Number',
    },
    enableReactionExportAsRDFile: {
      type: 'checkbox',
      label: 'Enable exporting reactions in RD file format',
    },
    enableJournalTitleRadioButtons: {
      type: 'checkbox',
      label: 'Enable Journal Title filter radio buttons',
    },
    enableEditSynonyms: {
      type: 'checkbox',
      label: 'Enable Edit Synonyms',
    },
    enableProjectImport: {
      type: 'checkbox',
      label: 'Enable Project Import',
    },
    enableBioactivityVisualizationButtonOnPreviewResults: {
      type: 'checkbox',
      label: 'Enable Bioactivity Visualization Button on Preview Results',
    },
    disableMicrosoftExcelNewLayoutInHeatMapExportModal: {
      type: 'checkbox',
      label: 'Disable Microsoft Excel New Layout in Heatmap Export Modal',
    },
    enableBioactivityVisualizationSettings: {
      type: 'checkbox',
      label: 'Enable Bioactivity Visualization Settings',
    },
    enableSortByPublicationYearDefault: {
      type: 'checkbox',
      label: 'Enable Sort by Publication Year by default',
    },
    enableStaticQuickSearchExamples: {
      type: 'checkbox',
      label: 'Enable static Quick Search examples',
    },
    enableAuthorNameSearchImprovements: {
      type: 'checkbox',
      label: 'Enable Author Name Search Improvements',
    },
    createAlertDaysBeforeNow: {
      type: 'number',
      label: 'Create Alert Retroactively (days before now)',
    },
    displayQuickSearchFormsButtons: {
      type: 'checkbox',
      label: 'Display Quick Search forms Buttons',
    },
    bundleExtraReactionData: {
      type: 'checkbox',
      label: 'Combine details and availability requests into initial response',
    },
    useHttpPolling: {
      type: 'checkbox',
      label: 'Disable Websockets and use HTTP Polling instead',
    },
    resultsPerPageIELimit: {
      type: 'checkbox',
      label: 'Results per page limits for IE11 enabled',
    },
  },
  integratedFeedback: {
    enableIntegratedFeedback: {
      type: 'checkbox',
      label: 'Enable Integrated Feedback',
    },
    bottomIntegratedFeedback: {
      type: 'checkbox',
      label: 'Enable bottom only position Integrated Feedback',
    },
    topAndBottomIntegratedFeedback: {
      type: 'checkbox',
      label: 'Enable top and bottom position Integrated Feedback',
    },
    extendedOnNegativeFeedbackOnly: {
      type: 'checkbox',
      label: 'Enable verbatim feedback for only negative ratings',
    },
  },
};

export const featureSwitchGroupLabelMapping = {
  feFeatureSwitch: 'FE Feature switches',
  integratedFeedback: 'Integrated Feedback Feature switches',
};
